<script>
import { required, email } from "vuelidate/lib/validators";
import { sharedHelper } from '@/utils';
import { authMethods } from "@/state/helpers";
import { MEDIUM } from '@/constants/enums';
import { mapState } from "vuex";
import { MODULE } from '@/state/modules/auth'

export default {
  data() {
    return {
      submitted: false,
      loginForm: {
        email: '',
        password: '',
        platform: sharedHelper.getPlatform(),
        domain: sharedHelper.getHostname(),
        option: 1,
        medium: MEDIUM.EMAIL,
      },
    };
  },
  computed: {
    ...mapState(MODULE, ['status']),
  },
  created() {
    document.body.classList.add("auth-body-bg");
  },
  validations: {
    loginForm: {
      email: { required, email },
      password: { required },
    }
  },
  methods: {
    ...authMethods,
    requestLogin() {
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        this.login({ data: this.loginForm });
      }
    }
  }
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div>
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-8">
            <div class="authentication-bg">
              <div class="bg-overlay"></div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div class="w-100">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <div class="text-center">
                        <div>
                          <a href="/" class="logo">
                            <img src="@/assets/logo_hextar_correct.png" style="height: 30%; width: 30%;" alt="logo" />
                          </a>
                        </div>

                        <h4 class="font-size-18 mt-4">{{ $t('label.welcomeBack') }}</h4>
                        <p class="text-muted">{{ $t('label.signInToContinueToProject', [$t('projectName')]) }}</p>
                      </div>

                      <div class="p-2 mt-5">
                        <form class="form-horizontal" @submit.prevent="requestLogin">
                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-mail-line auti-custom-input-icon"></i>
                            <label for="email">{{ $t('label.email') }}</label>
                            <input type="email" v-model="loginForm.email" class="form-control" id="email"
                              :placeholder="$t('label.enter', [$t('label.email')])"
                              :class="{ 'is-invalid': submitted && $v.loginForm.email.$error }" />
                            <div v-if="submitted && $v.loginForm.email.$error" class="invalid-feedback">
                              <span v-if="!$v.loginForm.email.required">{{ $t('message.requiredX', [$t('label.email')])
                              }}</span>
                              <span v-if="!$v.loginForm.email.email">{{ $t('message.validX', [$t('label.email')])
                              }}</span>
                            </div>
                          </div>

                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-lock-2-line auti-custom-input-icon"></i>
                            <label for="userpassword">{{ $t('label.password') }}</label>
                            <input v-model="loginForm.password" type="password" class="form-control" id="password"
                              :placeholder="$t('label.enter', [$t('label.password')])"
                              :class="{ 'is-invalid': submitted && $v.loginForm.password.$error }" />
                            <div v-if="submitted && !$v.loginForm.password.required" class="invalid-feedback">{{
                              $t('message.requiredX', [$t('label.password')]) }}</div>
                          </div>

                          <div class="mt-4 text-center">
                            <button class="btn btn-secondary w-md waves-effect waves-light" type="submit"
                              disabled>{{ $t('label.login') }}</button>
                          </div>

                          <div class="mt-4 text-center">
                            <!-- <router-link tag="a" to="/forgot-password" class="text-muted">
                              <i class="mdi mdi-lock mr-1"></i> {{ $t('label.forgotPassword') }}
                            </router-link> -->
                          </div>
                        </form>
                      </div>

                      <div class="mt-5 text-center">

                        <p>
                          © {{ new Date().getFullYear() }} .{{ $t('projectName') }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>